import {
  CustomCardWrapper,
  CustomCardBody,
  CustomCardBodyPlaceHolder
} from './styled';

export const TotalsBar = ({
  children
}: {
  children: React.JSX.Element;
}): React.JSX.Element => (
  <CustomCardWrapper>
    <CustomCardBody>
      <CustomCardBodyPlaceHolder>{children}</CustomCardBodyPlaceHolder>
    </CustomCardBody>
  </CustomCardWrapper>
);
